(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-complementary"] && !window.DesignMode) return;
  try {
    
  (function() {
    var modal = document.getElementById('complementary-modal-product');
    console.log(modal);
    if (! modal) return;
    

    var container = modal.querySelector('.product-recommendations');
    var closeEls = modal.querySelectorAll('[data-action="close-complementary-modal"]');
    function openModal() {
      modal.classList.remove('oup-modal--closed');
      modal.setAttribute('aria-hidden', 'false');
    }
    function closeModal() {
      modal.classList.add('oup-modal--closed');
      modal.setAttribute('aria-hidden', 'true');
    }
    closeEls.forEach(function(el) {
      el.addEventListener('click', closeModal);
    });

    function renderAndMaybeOpenFromHTML(htmlText) {
      var html = document.createElement('div');
      html.innerHTML = htmlText;
      var incoming = html.querySelector('.product-recommendations');
      if (incoming && incoming.innerHTML.trim().length > 0) {
        container.innerHTML = incoming.innerHTML;
        openModal();
      }
    }
    console.log(container);
    if (container) 
      console.log(container.innerHTML);
    

// If SSR already provided content (recommendations.products_count > 0), open immediately
    if (container && container.innerHTML.trim().length > 0) {
      openModal();
      return;
    }

// Fetch recommendations immediately and open when results exist
    var url = container && container.getAttribute('data-url');
    console.log(url);
    if (! url) return;
    
    fetch(url).then(function(response) {
      console.log(response);
      return response.text();
    }).then(function(text) {
      console.log(text);
      renderAndMaybeOpenFromHTML(text);
    }).catch(function(e) {
      console.error(e);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
